<template>
    <v-content>
        <v-snackbar :color="callbackResponse.color" :timeout="callbackResponse.timeout" top
                    v-model="callbackResponse.snackbar">
            {{callbackResponse.message}}
            <v-btn @click="callbackResponse.snackbar = false" dark text>Close</v-btn>
        </v-snackbar>

        <v-breadcrumbs :items="breadcrumbsItems" large></v-breadcrumbs>
            <div class="tbl-btn">
                <v-row>
                    <v-col class="btn-download" cols="2">
                        <v-btn @click="downloadData" color="green" dark>{{$t('download')}} {{$t('document')}}</v-btn>
                    </v-col>
                    <v-col cols="4" offset-sm="6">
                        <v-row>
                            <v-file-input label="upload file" show-size v-model="formData.document"></v-file-input>
                            <v-btn @click="uploadData" color="blue" dark>{{$t('upload')}} {{$t('document')}} </v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
    </v-content>
</template>

<script>
    // import {excelExport} from '@/mixins/excelExport'
    import axios from "axios";
    //import {required} from "vuelidate/lib/validators";
    export default {
        name: "direct7",
        data() {
            return {
                ubmitStatus: "",
                yearList: [],
                searchFormData: {
                    year:""
                },
                setYearValue: "",
                formData: {},
                tableData: [],
                search: false,
                callbackResponse: {
                    snackbar: false,
                    timeout: 6000,
                    message: ""
                },
               

            }
        },
        // mixins: [excelExport],
        computed: {
            breadcrumbsItems() {
               return [
                    {
                        text: this.$t('upload'),
                        disabled: false,
                        to: '/Upload/dashboard',
                        exact: true
                    },
                    {
                        text: this.$t('upload_document'),
                        disabled: true,
                    },
                ]
            } 
        },

        validations: {
          
        },

        mounted() {
           
        },


        methods: {

            downloadData() {
                axios({
                    url: 'Upload/DownloadDoc',
                    method: 'POST',
                    responseType: 'blob',
                    params: {
                        
                    }
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Document.docx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },
            
            uploadData() {
                var form = new FormData();
                form.append(
                    "File",
                    this.formData.document
                );

                axios.post('Upload/UploadDoc', form).then(response => {
                    console.log(response)
                        this.formData.excel = ""
                        this.callbackResponse.color = "success"
                        this.callbackResponse.snackbar = true
                        this.callbackResponse.message = "Data imported Successfullly."
                        this.searchSubmit()
                })
            }

        }
    }
</script>

<style lang="scss" scoped>
    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }

    .tbl-btn {
        padding: 1em;
        text-align: right;
    }

    .btn-download {
        text-align: left;
    }
    .total {
        background-color: #d2d2d2;
    }
</style>